import e0 from "../assets/englishNumbers/0.mp3";
import e1 from "../assets/englishNumbers/1.mp3";
import e2 from "../assets/englishNumbers/2.mp3";
import e3 from "../assets/englishNumbers/3.mp3";
import e4 from "../assets/englishNumbers/4.mp3";
import e5 from "../assets/englishNumbers/5.mp3";
import e6 from "../assets/englishNumbers/6.mp3";
import e7 from "../assets/englishNumbers/7.mp3";
import e8 from "../assets/englishNumbers/8.mp3";
import e9 from "../assets/englishNumbers/9.mp3";
import e10 from "../assets/englishNumbers/10.mp3";
import e11 from "../assets/englishNumbers/11.mp3";
import e12 from "../assets/englishNumbers/12.mp3";
import e13 from "../assets/englishNumbers/13.mp3";
import e14 from "../assets/englishNumbers/14.mp3";
import e15 from "../assets/englishNumbers/15.mp3";
import e16 from "../assets/englishNumbers/16.mp3";
import e17 from "../assets/englishNumbers/17.mp3";
import e18 from "../assets/englishNumbers/18.mp3";
import e19 from "../assets/englishNumbers/19.mp3";
import e20 from "../assets/englishNumbers/20.mp3";
import e21 from "../assets/englishNumbers/21.mp3";
import e22 from "../assets/englishNumbers/22.mp3";
import e23 from "../assets/englishNumbers/23.mp3";
import e24 from "../assets/englishNumbers/24.mp3";
import e25 from "../assets/englishNumbers/25.mp3";
import e26 from "../assets/englishNumbers/26.mp3";
import e27 from "../assets/englishNumbers/27.mp3";
import e28 from "../assets/englishNumbers/28.mp3";
import e29 from "../assets/englishNumbers/29.mp3";
import e30 from "../assets/englishNumbers/30.mp3";

import r0 from "../assets/russianNumbers/0.mp3";
import r1 from "../assets/russianNumbers/1.mp3";
import r2 from "../assets/russianNumbers/2.mp3";
import r3 from "../assets/russianNumbers/3.mp3";
import r4 from "../assets/russianNumbers/4.mp3";
import r5 from "../assets/russianNumbers/5.mp3";
import r6 from "../assets/russianNumbers/6.mp3";
import r7 from "../assets/russianNumbers/7.mp3";
import r8 from "../assets/russianNumbers/8.mp3";
import r9 from "../assets/russianNumbers/9.mp3";
import r10 from "../assets/russianNumbers/10.mp3";
import r11 from "../assets/russianNumbers/11.mp3";
import r12 from "../assets/russianNumbers/12.mp3";
import r13 from "../assets/russianNumbers/13.mp3";
import r14 from "../assets/russianNumbers/14.mp3";
import r15 from "../assets/russianNumbers/15.mp3";
import r16 from "../assets/russianNumbers/16.mp3";
import r17 from "../assets/russianNumbers/17.mp3";
import r18 from "../assets/russianNumbers/18.mp3";
import r19 from "../assets/russianNumbers/19.mp3";
import r20 from "../assets/russianNumbers/20.mp3";
import r21 from "../assets/russianNumbers/21.mp3";
import r22 from "../assets/russianNumbers/22.mp3";
import r23 from "../assets/russianNumbers/23.mp3";
import r24 from "../assets/russianNumbers/24.mp3";
import r25 from "../assets/russianNumbers/25.mp3";
import r26 from "../assets/russianNumbers/26.mp3";
import r27 from "../assets/russianNumbers/27.mp3";
import r28 from "../assets/russianNumbers/28.mp3";
import r29 from "../assets/russianNumbers/29.mp3";
import r30 from "../assets/russianNumbers/30.mp3";

import u0 from "../assets/ukraineNumbers/0.mp3";
import u1 from "../assets/ukraineNumbers/1.mp3";
import u2 from "../assets/ukraineNumbers/2.mp3";
import u3 from "../assets/ukraineNumbers/3.mp3";
import u4 from "../assets/ukraineNumbers/4.mp3";
import u5 from "../assets/ukraineNumbers/5.mp3";
import u6 from "../assets/ukraineNumbers/6.mp3";
import u7 from "../assets/ukraineNumbers/7.mp3";
import u8 from "../assets/ukraineNumbers/8.mp3";
import u9 from "../assets/ukraineNumbers/9.mp3";
import u10 from "../assets/ukraineNumbers/10.mp3";
import u11 from "../assets/ukraineNumbers/11.mp3";
import u12 from "../assets/ukraineNumbers/12.mp3";
import u13 from "../assets/ukraineNumbers/13.mp3";
import u14 from "../assets/ukraineNumbers/14.mp3";
import u15 from "../assets/ukraineNumbers/15.mp3";
import u16 from "../assets/ukraineNumbers/16.mp3";
import u17 from "../assets/ukraineNumbers/17.mp3";
import u18 from "../assets/ukraineNumbers/18.mp3";
import u19 from "../assets/ukraineNumbers/19.mp3";
import u20 from "../assets/ukraineNumbers/20.mp3";
import u21 from "../assets/ukraineNumbers/21.mp3";
import u22 from "../assets/ukraineNumbers/22.mp3";
import u23 from "../assets/ukraineNumbers/23.mp3";
import u24 from "../assets/ukraineNumbers/24.mp3";
import u25 from "../assets/ukraineNumbers/25.mp3";
import u26 from "../assets/ukraineNumbers/26.mp3";
import u27 from "../assets/ukraineNumbers/27.mp3";
import u28 from "../assets/ukraineNumbers/28.mp3";
import u29 from "../assets/ukraineNumbers/29.mp3";
import u30 from "../assets/ukraineNumbers/30.mp3";

import f0 from "../assets/frenchNumbers/0.mp3";
import f1 from "../assets/frenchNumbers/1.mp3";
import f2 from "../assets/frenchNumbers/2.mp3";
import f3 from "../assets/frenchNumbers/3.mp3";
import f4 from "../assets/frenchNumbers/4.mp3";
import f5 from "../assets/frenchNumbers/5.mp3";
import f6 from "../assets/frenchNumbers/6.mp3";
import f7 from "../assets/frenchNumbers/7.mp3";
import f8 from "../assets/frenchNumbers/8.mp3";
import f9 from "../assets/frenchNumbers/9.mp3";
import f10 from "../assets/frenchNumbers/10.mp3";
import f11 from "../assets/frenchNumbers/11.mp3";
import f12 from "../assets/frenchNumbers/12.mp3";
import f13 from "../assets/frenchNumbers/13.mp3";
import f14 from "../assets/frenchNumbers/14.mp3";
import f15 from "../assets/frenchNumbers/15.mp3";
import f16 from "../assets/frenchNumbers/16.mp3";
import f17 from "../assets/frenchNumbers/17.mp3";
import f18 from "../assets/frenchNumbers/18.mp3";
import f19 from "../assets/frenchNumbers/19.mp3";
import f20 from "../assets/frenchNumbers/20.mp3";
import f21 from "../assets/frenchNumbers/21.mp3";
import f22 from "../assets/frenchNumbers/22.mp3";
import f23 from "../assets/frenchNumbers/23.mp3";
import f24 from "../assets/frenchNumbers/24.mp3";
import f25 from "../assets/frenchNumbers/25.mp3";
import f26 from "../assets/frenchNumbers/26.mp3";
import f27 from "../assets/frenchNumbers/27.mp3";
import f28 from "../assets/frenchNumbers/28.mp3";
import f29 from "../assets/frenchNumbers/29.mp3";
import f30 from "../assets/frenchNumbers/30.mp3";


export const numbers = [
  {
    letter: "0",
    color: "#FFF11A",
  },
  {
    letter: "1",
    color: "#F06543",
  },
  {
    letter: "2",
    color: "#F99B28",
  },
  {
    letter: "3",
    color: "#FEF723",
  },
  {
    letter: "4",
    color: "#B5D444",
  },
  {
    letter: "5",
    color: "#0AADE8",
  },
  {
    letter: "6",
    color: "#EA259D",
  },
  {
    letter: "7",
    color: "#363190",
  },
  {
    letter: "8",
    color: "#F9403C",
  },
  {
    letter: "9",
    color: "#F5901E",
  },
  {
    letter: "10",
    color: "#FFF11A",
  },
  {
    letter: "11",
    color: "#B7D340",
  },
  {
    letter: "12",
    color: "#0AADE9",
  },
  {
    letter: "13",
    color: "#EA008D",
  },
  {
    letter: "14",
    color: "#2E2B92",
  },
  {
    letter: "15",
    color: "#F6A01A",
  },
  {
    letter: "16",
    color: "#F59120",
  },
  {
    letter: "17",
    color: "#F8EA13",
  },
  {
    letter: "18",
    color: "#B3D43A",
  },
  {
    letter: "19",
    color: "#04ACE4",
  },
  {
    letter: "20",
    color: "#D9077D",
  },
  {
    letter: "21",
    color: "#2E2E8C",
  },
  {
    letter: "22",
    color: "#ED3131",
  },
  {
    letter: "23",
    color: "#F7901B",
  },
  {
    letter: "24",
    color: "#F9F506",
  },
  {
    letter: "25",
    color: "#B7D64A",
  },
  {
    letter: "26",
    color: "#02AFE8",
  },
  {
    letter: "27",
    color: "#F06543",
  },
  {
    letter: "28",
    color: "#F99B28",
  },
  {
    letter: "29",
    color: "#FEF723",
  },
  {
    letter: "30",
    color: "#B5D444",
  },
];

export const audioNumbers = {
  english: {
    0: e0,
    1: e1,
    2: e2,
    3: e3,
    4: e4,
    5: e5,
    6: e6,
    7: e7,
    8: e8,
    9: e9,
    10: e10,
    11: e11,
    12: e12,
    13: e13,
    14: e14,
    15: e15,
    16: e16,
    17: e17,
    18: e18,
    19: e19,
    20: e20,
    21: e21,
    22: e22,
    23: e23,
    24: e24,
    25: e25,
    26: e26,
    27: e27,
    28: e28,
    29: e29,
    30: e30,
  },
  russian: {
    0: r0,
    1: r1,
    2: r2,
    3: r3,
    4: r4,
    5: r5,
    6: r6,
    7: r7,
    8: r8,
    9: r9,
    10: r10,
    11: r11,
    12: r12,
    13: r13,
    14: r14,
    15: r15,
    16: r16,
    17: r17,
    18: r18,
    19: r19,
    20: r20,
    21: r21,
    22: r22,
    23: r23,
    24: r24,
    25: r25,
    26: r26,
    27: r27,
    28: r28,
    29: r29,
    30: r30,
  },
  ukraine: {
    0: u0,
    1: u1,
    2: u2,
    3: u3,
    4: u4,
    5: u5,
    6: u6,
    7: u7,
    8: u8,
    9: u9,
    10: u10,
    11: u11,
    12: u12,
    13: u13,
    14: u14,
    15: u15,
    16: u16,
    17: u17,
    18: u18,
    19: u19,
    20: u20,
    21: u21,
    22: u22,
    23: u23,
    24: u24,
    25: u25,
    26: u26,
    27: u27,
    28: u28,
    29: u29,
    30: u30,
  },
  french: {
    0: f0,
    1: f1,
    2: f2,
    3: f3,
    4: f4,
    5: f5,
    6: f6,
    7: f7,
    8: f8,
    9: f9,
    10: f10,
    11: f11,
    12: f12,
    13: f13,
    14: f14,
    15: f15,
    16: f16,
    17: f17,
    18: f18,
    19: f19,
    20: f20,
    21: f21,
    22: f22,
    23: f23,
    24: f24,
    25: f25,
    26: f26,
    27: f27,
    28: f28,
    29: f29,
    30: f30,
  },
};
